function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
import { getMonth, getYear, isValid, subYears, getDate, isSameDay, isBefore } from "date-fns";
var DEFAULT_AGE = 30;
var FIRST_JULY_1934 = new Date("1934-07-01"); /**
                                              * Calculates age for LHC purposes as of a given date.
                                              * @param {Date|string} dobDate Date or ISO date string representing a persons date of birth.
                                              * @param {Date|string} baseDate The Date or ISO date string that represents the date at which to calculate the persons age.
                                              */
function ageForLhcPurposesAt(dateOfBirth, date) {
  var dobDate = dateOfBirth && isValid(new Date(dateOfBirth)) ? new Date(dateOfBirth) : subYears(new Date(), DEFAULT_AGE);
  var baseDate = date && isValid(new Date(date)) ? new Date(date) : new Date();
  var diffYears = getYear(baseDate) - getYear(dobDate);
  if (getMonth(baseDate) < getMonth(dobDate) || getMonth(baseDate) === getMonth(dobDate) && getDate(baseDate) <= getDate(dobDate)) {
    diffYears--;
  }
  return diffYears;
}
function startOfFinancialYear(insureDate) {
  var parsedDate = new Date(insureDate);
  var firstOfJuly = new Date(getYear(parsedDate), 6, 1);
  var firstOfJulyLastYear = new Date(getYear(parsedDate) - 1, 6, 1);
  return isBefore(parsedDate, firstOfJuly) || isSameDay(parsedDate, firstOfJuly) ? firstOfJulyLastYear : firstOfJuly;
} /**
  * Calculates the LHC age using a persons date of birth, cover start date, previous health cover status, and an optional certified age of entry override.
  * @param {{dateOfBirth, coverStartDate, hasPreviouslyHadHealthInsurance: boolean, certifiedAgeOfEntry}} options
  */
function calculateLhcAge(options) {
  if (_typeof(options) !== "object") {
    throw new TypeError("\"options\" must be of type object.");
  }
  var dateOfBirth = options.dateOfBirth,
    coverStartDate = options.coverStartDate,
    _options$hasPreviousl = options.hasPreviouslyHadHealthInsurance,
    hasPreviouslyHadHealthInsurance = _options$hasPreviousl === void 0 ? false : _options$hasPreviousl,
    certifiedAgeOfEntry = options.certifiedAgeOfEntry;
  var dobDate = dateOfBirth ? new Date(dateOfBirth) : null;
  if (certifiedAgeOfEntry && typeof certifiedAgeOfEntry !== "number") {
    throw new TypeError("\"certifiedAgeOfEntry\" must be of type number.");
  }
  if (typeof hasPreviouslyHadHealthInsurance !== "boolean") {
    throw new TypeError("\"hasPreviouslyHadHealthInsurance\" must be of type boolean.");
  } // if no DOB and CAE return default age OR when has had HI previously, and no CAE override return default age.
  if (!isValid(dobDate) && !certifiedAgeOfEntry || hasPreviouslyHadHealthInsurance && !certifiedAgeOfEntry) {
    return DEFAULT_AGE;
  }
  var insureDate = coverStartDate || new Date();
  if (dobDate <= FIRST_JULY_1934) return 30;
  var financialYear = startOfFinancialYear(insureDate);
  var lhcAge = ageForLhcPurposesAt(dobDate, financialYear); // certifiedAgeOfEntry is used as an override
  if (certifiedAgeOfEntry && certifiedAgeOfEntry < lhcAge) {
    lhcAge = certifiedAgeOfEntry;
  }
  if (lhcAge > 65) {
    return 65;
  }
  if (lhcAge < 30) {
    return 30;
  }
  return lhcAge;
}
function getLoadingFor(policyHolder, partner, startDate) {
  var policyHolderLoading = getPersonLoading(policyHolder, startDate); // With a partner, the LHC loading is the average
  if (partner) {
    var partnerLoading = getPersonLoading(partner, startDate);
    return (partnerLoading + policyHolderLoading) / 2;
  }
  return policyHolderLoading;
}
function getPersonLoading(personDetails, startDate) {
  var previouslyHadHealthInsurance = !personDetails || personDetails.previouslyHadHealthInsurance !== false;
  if (previouslyHadHealthInsurance) {
    return 0;
  }
  var dateOfBirth = isValid(new Date(personDetails.dateOfBirth)) && new Date(personDetails.dateOfBirth); // People born on or before this date have no health cover loading, see:
  // https://www.privatehealth.gov.au/health_insurance/surcharges_incentives/lifetime_health_cover.htm
  if (dateOfBirth && dateOfBirth <= new Date("1934-07-01")) {
    return 0;
  }
  var startOfFinancialYearDate = startOfFinancialYear(startDate);
  var ageForLhcPurposes = ageForLhcPurposesAt(dateOfBirth, startOfFinancialYearDate);
  if (personDetails && ageForLhcPurposes <= 30) {
    return 0;
  }
  if (personDetails && ageForLhcPurposes >= 65) {
    return 70;
  } // age is above 30 but below 65, therefore the loading increases by 2% each year
  return (ageForLhcPurposes - 30) * 2;
}
export { calculateLhcAge, ageForLhcPurposesAt, startOfFinancialYear, getLoadingFor, getPersonLoading };